import { render, staticRenderFns } from "./AnaliseDocumentacaoCabecalhoCredenciamento.vue?vue&type=template&id=fa803f2c&scoped=true"
import script from "./AnaliseDocumentacaoCabecalhoCredenciamento.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoCabecalhoCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoCabecalhoCredenciamento.vue?vue&type=style&index=0&id=fa803f2c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa803f2c",
  null
  
)

export default component.exports